export default __webpack_public_path__ + "static/media/oscer-product-score.3724dda8.png";